
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import copy from 'copy-to-clipboard'
import highlight from '../highlight'

const convertPathToName = path => path
  .split('/')
  .filter(folder => folder !== '.')
  .map(item => item.replace(/\.html$/, ''))
  .join('-')

function requireAll(requireContext) {
  return requireContext.keys().reduce((acc, key) => {
    acc[convertPathToName(key)] = requireContext(key)
    return acc
  }, {})
}

const snippets = requireAll(require.context('./snippets', true, /^\.\/.*\.html$/))

const DEFAULT_FRONTEND_ID = 'YOUR_FRONTEND_ID'

function selectText(element) {
  const doc = document
  let range
  let selection

  if (doc.body.createTextRange) { // ms
    range = doc.body.createTextRange()
    range.moveToElementText(element)
    range.select()
  } else if (window.getSelection) { // all others
    selection = window.getSelection()
    range = doc.createRange()
    range.selectNodeContents(element)
    selection.removeAllRanges()
    selection.addRange(range)
  }
}

class Snippet extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(Object.keys(snippets)),
    frontendId: PropTypes.string
  }

  static defaultProps = {
    frontendId: DEFAULT_FRONTEND_ID
  }

  state = {
    copied: false
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  render() {
    const {frontendId, type} = this.props
    const {copied} = this.state
    const code = highlight.highlight('xml', snippets[type]).value
    const html = code.split(DEFAULT_FRONTEND_ID)
    for (let i = html.length - 1; i > 0; i--) {
      html.splice(i, 0, `<strong class='snippet-frontendId'>${frontendId}</strong>`)
    }

    return (
      <div className='snippet'>
        <div
          onClick={evt => selectText(evt.currentTarget)}
          className='snippet-item hljs'
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{__html: html.join('')}}
        />
        <div className='snippet-copyToClipboard' onClick={this.copyToClipboard}>
          {copied ? 'Copied!' : 'Copy to clipboard'}
        </div>
      </div>
    )
  }

  copyToClipboard = () => {
    const {frontendId, type} = this.props
    copy(snippets[type].replace(DEFAULT_FRONTEND_ID, frontendId))
    this.setState({copied: true})
    this.timeout = setTimeout(() => {
      this.setState({copied: false})
      this.timeout = null
    }, 1000)
  }
}

export default Snippet



// WEBPACK FOOTER //
// ./client/components/Wizard/Snippet/index.js